import { Button, Dropdown } from "antd";
import { useMemo, useState } from "react";
import ExportReportModal from "../../Modal/ExportReportModal";

type ExportType = "excel" | "pdf" | null;

interface ExportReportButtonProps {
	defaultCurrentUser?: boolean;
	openCalendar?: boolean;
	activeProject?: any;
}

function ExportReportButton({
	defaultCurrentUser,
	openCalendar,
	activeProject,
}: ExportReportButtonProps) {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [exportType, setExportType] = useState<ExportType>(null);

	const handleMenuClick = (type: ExportType) => {
		setExportType(type);
		setIsModalOpen(true);
	};

	const handleCloseModal = () => {
		setIsModalOpen(false);
		setExportType(null);
	};

	// When !defaultCurrentUser && !openCalendar, remove PDF from dropdown
	const menuItems = useMemo(() => {
		const items = [
			{
				key: "excel",
				label: <div onClick={() => handleMenuClick("excel")}>Excel</div>,
			},
		];

		if (defaultCurrentUser || openCalendar) {
			items.push({
				key: "pdf",
				label: <div onClick={() => handleMenuClick("pdf")}>PDF</div>,
			});
		}

		return items;
	}, [defaultCurrentUser, openCalendar]);

	return (
		<>
			<Dropdown menu={{ items: menuItems }} trigger={["click"]}>
				<Button>Export Report</Button>
			</Dropdown>
			<ExportReportModal
				open={isModalOpen}
				onClose={handleCloseModal}
				exportType={exportType}
				defaultCurrentUser={defaultCurrentUser}
				openCalendar={openCalendar}
				activeProject={activeProject}
			/>
		</>
	);
}

export default ExportReportButton;
